import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  margin: 0;\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  margin-left: ", ";\n  margin-right: ", ";\n  min-width: 0; /* fixes ellipsis problems using flexbox */\n\n  &:first-child {\n    margin-left: 0;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      text-decoration: none;\n\n      &:hover {\n        color: ", ";\n        text-decoration: none;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: inherit;\n  color: inherit;\n  display: inherit;\n  flex: 1;\n  min-width: inherit;\n  overflow: visible;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      box-shadow: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  ", "\n\n  box-sizing: border-box;\n  display: flex;\n  height: ", "px;\n  min-height: ", "px;\n  min-width: 0; /* fixes ellipsis problems using flexbox */\n  overflow: hidden;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  position: relative;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { ellipsis } from 'polished';
import { FetchingStatus } from '@scp/ui-shared/core';
import { Heading1, Heading2, Paragraph } from '@scp/ui-shared/components/typography';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { TextLoader } from '@scp/ui-shared/components/loaders';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { size, property, color, zIndex } from '@scp/ui-shared/theme/variables';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { Spacing } from './Spacing';
export var HEADER_TOOLBAR_E2E_SUFFIX = '-header-toolbar';
var Toolbar = styled.header(_templateObject(), color.background, function (props) {
  return props.withShadow && css(_templateObject2(), property.boxShadow);
}, size.appBarHeight, size.appBarHeight, function (props) {
  return props.hasPrimaryAction ? baselineToRem(1) : baselineToRem(4);
}, function (props) {
  return props.hasSecondaryAction ? baselineToRem(1) : baselineToRem(4);
}, zIndex.appBar);
var ClickableWrapper = styled(withRippleEffect(LinkOrButton))(_templateObject3(), function (_ref) {
  var to = _ref.to,
      href = _ref.href;
  return (to || href) && css(_templateObject4(), color.background, color.background);
});
var Content = styled.span(_templateObject5(), baselineToRem(2), baselineToRem(2));

var getAccessibilityProps = function getAccessibilityProps(_ref2) {
  var isButton = _ref2.isButton,
      ariaLevel = _ref2.ariaLevel;
  return {
    as: isButton ? 'span' : "h".concat(ariaLevel),
    role: isButton && 'heading',
    'aria-level': isButton && "".concat(ariaLevel)
  };
};

var TitlePrimary = styled(Heading1).attrs(function (_ref3) {
  var isButton = _ref3.isButton;
  return Object.assign({
    noMargin: true
  }, getAccessibilityProps({
    isButton: isButton,
    ariaLevel: 1
  }));
})(_templateObject6(), ellipsis());
var TitleSecondary = styled(Heading2).attrs(function (_ref4) {
  var isButton = _ref4.isButton;
  return Object.assign({
    noMargin: true
  }, getAccessibilityProps({
    isButton: isButton,
    ariaLevel: 1
  }));
})(_templateObject7(), ellipsis());
var Subtitle = styled(Paragraph).attrs(function (_ref5) {
  var isButton = _ref5.isButton;
  return Object.assign({
    secondary: true
  }, getAccessibilityProps({
    isButton: isButton,
    ariaLevel: 2
  }));
})(_templateObject8(), baselineToRem(4), ellipsis());
/**
 * A HeaderToolbar component. A simple alternative to Material UI's App Bar:
 * http://www.material-ui.com/#/components/app-bar.
 *
 * Used mainly as header for content sections, modals and etc.
 *
 * @example ./__docs__/HeaderToolbar.md
 */

export var HeaderToolbar = function HeaderToolbar(_ref6) {
  var avatar = _ref6.avatar,
      linkTo = _ref6.linkTo,
      subtitle = _ref6.subtitle,
      title = _ref6.title,
      onClick = _ref6.onClick,
      secondaryAction = _ref6.secondaryAction,
      primaryAction = _ref6.primaryAction,
      className = _ref6.className,
      _ref6$withShadow = _ref6.withShadow,
      withShadow = _ref6$withShadow === void 0 ? false : _ref6$withShadow,
      _ref6$loadingStatus = _ref6.loadingStatus,
      loadingStatus = _ref6$loadingStatus === void 0 ? FetchingStatus.Initial : _ref6$loadingStatus,
      dataE2e = _ref6.dataE2e;
  var isButton = onClick && !linkTo;
  var content = React.createElement(React.Fragment, null, !!avatar && React.createElement(Spacing, {
    marginRight: 2,
    as: 'span'
  }, avatar), React.createElement(Content, {
    as: isButton ? 'span' : 'div'
  }, React.createElement(TextLoader, {
    status: loadingStatus,
    width: 150
  }, !!title && (subtitle ? React.createElement(TitleSecondary, {
    isButton: isButton
  }, title) : React.createElement(TitlePrimary, {
    isButton: isButton
  }, title))), React.createElement(TextLoader, {
    status: loadingStatus,
    width: 100
  }, !!subtitle && React.createElement(Subtitle, {
    isButton: isButton
  }, subtitle)))); // Additionally wrap with <button /> if onClick is provided

  return React.createElement(Toolbar, {
    className: className,
    hasPrimaryAction: !!primaryAction,
    hasSecondaryAction: !!secondaryAction,
    withShadow: withShadow,
    "data-e2e": getE2eLabel(dataE2e, HEADER_TOOLBAR_E2E_SUFFIX)
  }, primaryAction, onClick || linkTo ? React.createElement(ClickableWrapper, {
    onClick: onClick,
    to: linkTo,
    type: !linkTo ? 'button' : undefined
  }, content) : content, secondaryAction);
};